import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <Link
    to=''
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className='dropdown-icon'
    aria-label='Options menu'
  >
    {children}
    <IcomoonReact iconSet={iconSet} size={30} icon='dots' color='#9e9e9e' />
  </Link>
));

CustomToggle.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
};

CustomToggle.defaultProps = {
  children: null,
  onClick: () => {},
};

export default CustomToggle;
